// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wrapper[data-v-ee80bcd4] {
  background: white;
  position: absolute;
  top: 64px;
  left: 50%;
  transform: translateX(-50%);
  border: 3px solid grey;
  text-align: left;
  line-height: 1.75;
  padding: 0;
  min-width: 500px;
  width: auto;
  border-radius: 10px;
  z-index: 999;
}
.circle-icon[data-v-ee80bcd4] {
  height: 60px;
  width: 60px;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;
  border: 5px solid;
  border-radius: 50%;
  font-weight: bold;
}
.policy-score-match--success[data-v-ee80bcd4] {
  background: #0080005c;
}
.policy-score-match--failed[data-v-ee80bcd4] {
  background: pink;
}
.text-success[data-v-ee80bcd4] {
  color: green;
}
.text-error[data-v-ee80bcd4] {
  color: red;
}
.call-vibration[data-v-ee80bcd4] {
  animation-name: spaceboots;
  animation-duration: 0.8s;
  transform-origin: 50% 50%;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  cursor: pointer;
  border-color: green;
}
.intro-message[data-v-ee80bcd4] {
  text-align: justify;
  width: 100%;
  max-width: 380px;
  padding-right: 20px;
}
.close-modal[data-v-ee80bcd4] {
  position: absolute;
  right: 0;
  padding: 5px;
}
.close-modal[data-v-ee80bcd4]:hover {
  background: #ff000030;
  cursor: pointer;
}
.user-detail[data-v-ee80bcd4] {
  flex: 1;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
